import { PatientWithStatsGetterNames } from './keys'
import { PatientWithStatsState } from './types'
import { FlatAPIData, flattenJsonApiResponse } from '@/store/utils/converter'
import { PatientWithStatsAttributes } from '@/jsonapi/PatientWithStats'
import { getPatientName } from '@/utils/patients'

export type FlatPatientWithStats = FlatAPIData<PatientWithStatsAttributes>

/* tslint:disable:no-shadowed-variable */
export const getters = {
  [PatientWithStatsGetterNames.PatientWithStats]: (state: PatientWithStatsState): FlatPatientWithStats[] => {
    return state.patientWithStats.map(flattenJsonApiResponse).sort((a, b) =>
      getPatientName(a)
        .toLowerCase()
        .localeCompare(getPatientName(b).toLowerCase())
    )
  },
}
